import { PivotWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Pivot')
export class PivotConnectorProvider extends ConnectorProvider<PivotWorkflowNode> {}
